import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function DialogAction(props) {

    const closeDialog = () => {
        props.setOpen(false)
    }

    const confirmDialog = async () => {
        await props.statusCb(props.row)
        closeDialog()
    }

    return (
        <Dialog open={props.open} keepMounted onClose={closeDialog} aria-describedby="alert-dialog-slide-description">
            {/* {console.log("Abrir", props.open)} */}
            <DialogTitle>{"Remover"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {`Deseja realmente remover esta fazenda?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={confirmDialog}>
                    Confirmar
                </Button>
                <Button onClick={closeDialog}>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    )
}